import useSWR from 'swr';
// api
import { priceSuggestionFetcher } from './priceSuggestionFetcher';

const usePriceSuggestion = ({ ticket_id, priceSuggestionDTOString }) => {
  const priceSuggestionRequestKey = 'priceSuggestion';

  const { data: priceSuggestion, error: priceSuggestionError } = useSWR(
    [priceSuggestionRequestKey, ticket_id, priceSuggestionDTOString],
    priceSuggestionFetcher,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingPriceSuggestion = typeof priceSuggestion === 'undefined';

  return {
    isLoadingPriceSuggestion,
    priceSuggestion,
    priceSuggestionError,
  };
};

export default usePriceSuggestion;
